import * as FullStory from '@fullstory/browser';

/**
 * Initialize FullStory for user session recording and analytics.
 * Only initializes in production environment.
 */
export const initializeFullStory = () => {
  // Only initialize FullStory in production environment
  if (process.env.REACT_APP_ENV === 'production') {
    const orgId = process.env.REACT_APP_FULLSTORY_ORG_ID || 'Y34CM';
    FullStory.init({
      orgId,
      devMode: false,
      // Enable recording of cross-domain iframes (e.g. Plaid), with sensitive data
      // masked/obfuscated via FullStory dashboard configuration and DOM attributes.
      recordCrossDomainIFrames: true,
    });
  }
};
